import { render, staticRenderFns } from "./seurantakeskustelut-kouluttaja-vastuuhenkilo.vue?vue&type=template&id=079073ee&scoped=true&"
import script from "./seurantakeskustelut-kouluttaja-vastuuhenkilo.vue?vue&type=script&lang=ts&"
export * from "./seurantakeskustelut-kouluttaja-vastuuhenkilo.vue?vue&type=script&lang=ts&"
import style0 from "./seurantakeskustelut-kouluttaja-vastuuhenkilo.vue?vue&type=style&index=0&id=079073ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079073ee",
  null
  
)

export default component.exports